import { handleSessionLost } from '../utils/gate'
// Р’ development СЂРµР¶РёРјРµ РёСЃРїРѕР»СЊР·СѓРµРј РїСЂРѕРєСЃРё, РІ production - РїРѕР»РЅС‹Р№ URL
// РСЃРїРѕР»СЊР·СѓРµРј РѕС‚РЅРѕСЃРёС‚РµР»СЊРЅС‹Р№ РїСѓС‚СЊ - nginx РїСЂРѕРєСЃРёСЂСѓРµС‚ /api/* Рє Р±СЌРєРµРЅРґСѓ
/** Единый вход подтвердил человека, но допуска к CRM нет (или task недоступен): страница «нет доступа», не вход. */
export class GateAccessError extends Error {
  code: string
  constructor(message: string, code: string) {
    super(message)
    this.name = 'GateAccessError'
    this.code = code
  }
}

export const API_BASE_URL = typeof window !== 'undefined' && window.location.hostname === 'crm.ecmit.su'
  ? 'https://ecmit.su/api'
  : '/api'

console.log('API: Р‘Р°Р·РѕРІС‹Р№ URL:', API_BASE_URL)
console.log('API: Р РµР¶РёРј СЂР°Р·СЂР°Р±РѕС‚РєРё:', import.meta.env.DEV)

// РўРёРїС‹ РґР°РЅРЅС‹С…
export interface User {
  id: number
  username: string
  name: string
  role: 'employee' | 'employee' | 'admin'
  email?: string
  contract_code?: string
}

export interface AuthResponse {
  success: boolean
  token?: string
  user?: User
  message?: string
}

export interface EmailAuthRequest {
  email: string
  password: string
}

export interface Contract {
  id: number
  code: string
  title: string
  owner_name: string
  is_active: boolean
  year?: number
  division?: 'lmo3' | 'spb'
  contract_reference?: string | null
}

export interface LogisticsRoute {
  key: string
  label: string
  distance_km: number
  trips: number
  positions: number
  toll_per_trip: number
  fuel_per_trip: number
  cost_per_trip: number
  total_cost: number
  cost_per_position: number
  cost_per_position_km: number
  /** У маршрута может быть свой расход/топливо, отдельно от верхнеуровневых полей. */
  fuel_price: number
  fuel_consumption: number
}

export interface LogisticsMoscowLocal {
  weekly_km: number
  weeks_measured: number
  measured_period: { from: string; to: string }
  toll_per_week: number
  fuel_per_week: number
  cost_per_week: number
  cost_per_km: number
  fuel_price: number
  fuel_consumption: number
  primary_contracts: string[]
  secondary_contracts: string[]
}

export interface LogisticsSummary {
  year: number
  fuel_price: number
  fuel_consumption: number
  routes: LogisticsRoute[]
  contracts: Array<{ title: string; positions: number; cost: number }>
  flows: { to_check: number; to_issue: number }
  total_cost: number
  total_positions: number
  total_trips: number
  period: { from: string | null; to: string | null }
  /** Городская логистика по Москве — отдельная модель, не привязана к рейсам/накладным. */
  moscow_local: LogisticsMoscowLocal
}

export interface Asset {
  id: number
  asset_uid: string
  name: string
  type_si: string
  serial: string
  contract_id: number
  contract_code: string
  contract_title: string
  contract_division?: 'lmo3' | 'spb'
  owner_name: string
  current_status: string
  status?: string
  status_note?: string
  has_updates?: boolean
  date_recv?: string
  date_sent?: string
  date_got?: string
  date_ret?: string
  mit_number?: string
  work_type?: string
  inspector?: string
  current_inspector?: string
  invoice_number?: string
  invoice_date?: string
  invoice_raw?: string
  fgis_vri_id?: string
  shelf_location?: string | null
  created_at?: string
  updated_at?: string
  linked_photos_count?: number
  draft_act_id?: number | null
  draft_act_number?: string | null
  draft_act_name?: string | null
  draft_act_created_by?: string | null
  draft_waybill_id?: number | null
  draft_waybill_number?: string | null
  draft_waybill_purpose?: string | null
}

export interface BulkShelfAssetsResponse {
  selected_shelves: string[]
  year?: number
  count: number
  assets: Asset[]
  shelf_counts: Record<string, number>
  contracts: Array<{ code: string; title: string; count: number }>
  owners: Array<{ name: string; count: number }>
  not_found?: string[]
}

export interface ChatSession {
  id: number
  owner_email: string
  title: string
  consultant_mode: boolean
  system_prompt: string
  model_id: string
  created_at: string
  updated_at: string
  is_owner: boolean
  messages_count?: number
  last_message_at?: string
  shared_with?: Array<{
    shared_with_email: string
    shared_by_email: string
    created_at: string
  }>
}

export interface ChatModel {
  id: string
  label: string
  description: string
  context_window: number
  max_output_tokens: number
  available: boolean
  is_default: boolean
}

export interface ChatMessage {
  id: number
  session_id: number
  role: 'user' | 'assistant' | 'system'
  content: string
  created_at: string
  meta?: Record<string, any>
}

export interface DesktopRelease {
  version: string
  name: string
  size: number
  download_url: string
  release_url: string
  published_at: string
  notes: string
}

export interface DesktopDownload {
  platform: 'windows' | 'macos' | 'android'
  architecture: 'x64' | 'arm64' | 'universal'
  label: string
  name: string
  size: number
  download_url: string
  warning?: string
  version: string
}

export interface PlatformRelease {
  channel: 'stable' | 'preview'
  version: string
  release_url: string
  published_at: string
  notes: string
  downloads: DesktopDownload[]
}

export interface EmployeeInfo {
  email: string
  name: string
  is_me: boolean
}

export interface StaffDirectoryUser {
  id?: number
  email: string
  name: string
  role?: string
  source?: string
}

export interface EmployeeAccountProfile {
  email: string
  name: string
  role: string
  is_active: boolean
  can_manage_staff: boolean
}

export interface EmployeeAccountDocument {
  id: number
  document_type: 'shipment_act' | 'waybill' | 'print_tag' | 'tag' | 'distribution' | 'subcontractor_application'
  number: string
  title: string
  context: string
  status: 'draft' | 'archived'
  year?: number | null
  created_at: string
  completed_at?: string | null
  items_count: number
  link: string
}

export interface EmployeeAccountRequest {
  id: number
  request_type: 'contract_request' | 'service_request'
  status: string
  customer_email: string
  customer_label?: string
  title: string
  context: string
  created_at: string
  last_action_at: string
  last_message?: string | null
  items_count: number
  link: string
}

export interface EmployeeAccountData {
  profile: EmployeeAccountProfile
  summary: {
    draft_documents: number
    archived_documents: number
    processed_requests: number
  }
  recent_documents: EmployeeAccountDocument[]
  recent_requests: EmployeeAccountRequest[]
}

export interface EmployeeAccountPage<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export interface RagFeedbackReport {
  id: number
  session_id?: number | null
  reporter_email: string
  query_text: string
  response_text?: string | null
  fif_hint?: string | null
  si_type_hint?: string | null
  notes?: string | null
  created_at: string
}

export type EmployeeFeedbackCategory = 'bug' | 'feature' | 'improvement' | 'question'
export type EmployeeFeedbackStatus = 'new' | 'in_progress' | 'resolved' | 'rejected'

export interface EmployeeFeedbackAttachment {
  id: number
  original_name: string
  mime_type?: string | null
  size: number
  created_at: string
}

export interface EmployeeFeedback {
  id: number
  category: EmployeeFeedbackCategory
  subject: string
  body: string
  reporter_email: string
  reporter_name: string
  page_url?: string | null
  user_agent?: string | null
  status: EmployeeFeedbackStatus
  admin_note?: string | null
  created_at: string
  updated_at: string
  resolved_at?: string | null
  attachments: EmployeeFeedbackAttachment[]
}

export interface ContractStats {
  missing_serials: number
  waiting_distribution: number
  in_work: number
  ready: number
  issued: number
  not_received: number
  totals: {
    in_work: number
    ready: number
    issued: number
  }
}

export interface ContractTabsResponse {
  items: Asset[]
  total: number
  page: number
  page_size: number
}

export interface AssetPhoto {
  id: number
  kind: string
  note: string
  url: string
  thumb_url?: string
  file_path?: string
  thumb_path?: string
  taken_at: string
  source?: 'local' | 'yandex_disk'
  yandex_photo_id?: number
  disk_path?: string
  name?: string
}

export interface AssetPhotosByKind {
  [key: string]: AssetPhoto[]
}

export interface YandexPhoto {
  id: number
  name: string
  disk_path: string
  preview_url?: string
  url?: string
  thumb_url?: string
  taken_at?: string
  modified_at?: string
  size?: number
  media_type?: string
  links_count?: number
  linked_asset_uids?: string[]
  linked_kinds?: string[]
  linked_links?: Array<{
    asset_uid: string
    kind: string
    linked_at?: string
    asset_serial?: string
    asset_name?: string
  }>
}

export interface PhotoBatch {
  id: number
  source: string
  date: string
  location_hint?: string
  disk_folder?: string
  status: 'collecting' | 'ready' | 'indexed' | string
  photos_count: number
  files_count?: number
  last_seen_at?: string
  ready_at?: string
}

export interface AcceptancePhotoWorkspace {
  assets: Asset[]
  photos: YandexPhoto[]
  date: string
  contract_code: string
}

export interface AcceptancePhotoLinkItem {
  asset_uid: string
  photo_ids: number[]
}

export interface VaultTreeResponse {
  ok: boolean
  divisions?: Array<{ name: string; id?: string }>
  contracts?: Array<{ name: string; id?: string }>
  dates?: string[]
}

export interface FGISCheck {
  found: boolean
  vri_id?: string
  org_title?: string
  verification_date?: string
  result_docnum?: string
  url?: string
  fgis_info?: {
    valid_date?: string
    days_left?: number
    reg_number?: string
    rank_title?: string
    protocol_url?: string
    is_etalon?: boolean
  }
}

export interface RostestStatement {
  status: 'found' | 'not_found' | 'error' | 'ambiguous'
  invoice_number: string
  statement_number?: string | null
  statement_date?: string | null
  doc_status?: string | null
  amount?: string | null
  place?: string | null
  contract?: string | null
  issue_date?: string | null
  reason?: string | null
  checked_at?: string | null
  items_checked_at?: string | null
  items_total?: number | null
  items_issued?: number | null
}

/** Строка «Расшифровки услуги» ЗК этого прибора: выдал ли его Ростест (нашим курьерам) и когда. */
export interface RostestStatementItem {
  serial: string
  issued: 0 | 1
  issue_date?: string | null
  first_seen_at?: string | null
  marked_at?: string | null
}

export interface RostestCertificate {
  status?: 'matched' | 'review' | 'not_found' | 'error'
  reason?: string
  certificate_number?: string
  work_date?: string
  valid_until?: string
  certificate_url?: string
  protocol_url?: string
}

// РўРёРїС‹ РґР»СЏ РґРѕРєСѓРјРµРЅС‚РѕРѕР±РѕСЂРѕС‚Р°
export interface ShipmentAct {
  id: number
  number: string
  name: string
  contract_code: string
  contract_title: string
  customer: string
  created_by: string
  status: 'draft' | 'archived'
  created_at: string
  finalized_at?: string
  file_path?: string
  notes?: string
  items_count: number
}

export interface ShipmentActItem {
  id: number
  act_id: number
  asset_uid: string
  serial_number: string
  asset_name: string
  asset_type: string
  category: string
  is_manual?: boolean
  include_rostest_pdf: boolean
  rostest_certificate_status?: string | null
  rostest_certificate_number?: string | null
  rostest_certificate_url?: string | null
  added_at: string
}

export interface RostestDocumentJob {
  id: string
  status: 'queued' | 'running' | 'completed' | 'failed'
  total: number
  processed: number
  phase?: 'queued' | 'fgis' | 'rostest' | 'completed' | 'failed'
  stats: {
    fgis_checked?: number
    fgis_found?: number
    fgis_errors?: number
    checked: number
    matched: number
    not_found: number
    skipped: number
    errors: number
  }
  error?: string | null
}

export interface CreateShipmentActData {
  number: string
  name: string
  contract_code: string
  customer: string
  notes?: string
}

export interface DropdownAct {
  id: number
  number: string
  name: string
  items_count: number
}

export interface NextDocumentNumber {
  next_number: string
}

export type SubcontractorOptionValue = 'yes' | 'no'

export interface SubcontractorTemplate {
  code: string
  title: string
  template_key: string
  number_prefix: string
  item_fields: string[]
  extra_options: string[]
  requires_agreement: boolean
}

export interface SubcontractorApplication {
  id: number
  subcontractor_id: number
  subcontractor_code: string
  subcontractor_title: string
  template_key: string
  contract_id: number
  contract_code: string
  contract_title: string
  year: number
  owner_name: string
  outgoing_number: string
  outgoing_date: string
  owner_full_name: string
  owner_inn: string
  agreement_number: string
  agreement_date: string
  customer_card_number: string
  notes: string
  paper_certificate: SubcontractorOptionValue
  paper_certificate_note: string
  reduced_scope: SubcontractorOptionValue
  reduced_scope_note: string
  calibration_method: SubcontractorOptionValue
  calibration_method_note: string
  verification_protocol: SubcontractorOptionValue
  verification_protocol_note: string
  fgis_owner: SubcontractorOptionValue
  fgis_owner_note: string
  status: 'draft' | 'archived'
  created_by: string
  created_at: string
  updated_at: string
  archived_at?: string | null
  file_path?: string | null
  items_count: number
}

export interface SubcontractorApplicationItem {
  id: number
  application_id: number
  asset_uid: string
  work_code: 'П' | 'К' | 'А' | 'МКС' | 'И'
  asset_name: string
  asset_type: string
  mit_number: string
  serial: string
  quantity: number
  measurement_details: string
  metrology_details: string
  urgency: string
  transport_preparation: string
  completeness: string
  manufacture_year: string
  performer?: string
  performer_warning?: boolean
}

export interface SubcontractorApplicationDropdown {
  id: number
  name: string
  outgoing_number: string
  items_count: number
}

// РўРёРїС‹ РґР»СЏ РЅР°РєР»Р°РґРЅС‹С…
export interface Waybill {
  id: number
  number: string
  purpose: string
  ship_date: string     // ISO
  created_by: string
  status: 'draft' | 'archived'
  created_at: string
  finalized_at?: string
  file_path?: string
  notes?: string
  origin?: string
  sender_name?: string
  sender_title?: string
  cargo_responsible?: string
  items_count: number
}

export interface WaybillPhoto {
  id: number
  name: string
  url: string
  media_type?: string
  linked?: boolean
  batch_date?: string
  sender?: string
  disk_folder?: string
}

export interface WaybillPhotoSuggestion {
  sender: string
  direction: string
  ship_date?: string
  branches: string[]
  dates: Array<{ date: string; diff_days: number | null }>
  selected: string | null
}

export interface LabTransferItem {
  asset_uid: string
  name: string
  type_si: string
  serial: string
  contract_code: string
  contract_title: string
}

export interface LabTransfer {
  id: number
  code: string
  status: 'draft' | 'sent' | 'in_progress' | 'done' | 'cancelled'
  lab_unit_id?: number | null
  lab_name: string
  assignee_email: string
  assignee_name: string
  note: string
  created_by: string
  created_by_email: string
  created_at: string
  sent_at?: string | null
  task_id?: string | null
  task_url?: string | null
  task_status?: string | null
  task_done_comment?: string | null
  mail_status?: string | null
  last_error?: string | null
  card_url?: string
  items?: LabTransferItem[]
  photos?: WaybillPhoto[]
  items_count?: number
  photos_count?: number
}

export interface LabTransferLabs {
  configured: boolean
  labs: Array<{ id: number; name: string; head_email: string }>
  staff: Array<{ email: string; display_name: string; primary_unit?: string; position?: string }>
}

export interface WaybillItem {
  id: number
  waybill_id: number
  asset_uid: string
  serial_number: string
  asset_name: string
  asset_type: string
  owner_title: string
  destination: string
  is_manual?: boolean
  manual_qty?: string | null
  include_rostest_pdf: boolean
  rostest_certificate_status?: string | null
  rostest_certificate_number?: string | null
  rostest_certificate_url?: string | null
  added_at: string
}

export interface CreateWaybillData {
  number: string
  purpose: string
  ship_date: string
  origin: string
  sender_name: string
  sender_title: string
  cargo_responsible: string
  notes?: string
}

export interface DropdownDoc {
  id: number
  number: string
  origin: string
  purpose: string
  name: string          // В«РќР°РєР»Р°РґРЅР°СЏ в„–вЂ¦ (N)В»
  items_count: number
}

export interface AssetDocumentHistoryItem {
  document_type: 'shipment_act' | 'waybill' | 'subcontractor_application'
  document_id: number
  number: string
  title: string
  status: 'draft' | 'archived'
  document_date?: string
  date_source: 'document' | 'created' | 'finalized'
  origin?: string
  destination?: string
  created_by: string
}

// РўРёРїС‹ РґР»СЏ Р±РёСЂРѕРє РЅР° РїРµС‡Р°С‚СЊ
export interface PrintTag {
  id: number
  name: string
  created_by: string
  status: string
  created_at: string
  finalized_at?: string
  file_path?: string
  notes?: string
  items_count: number
}

export interface PrintTagItem {
  id: number
  print_tag_id: number
  asset_uid: string
  note?: string
  copies: number
  added_at: string
  serial: string
  asset_name: string
  asset_type?: string
  contract_title: string
  date_recv?: string
  inspector?: string
}

export interface CreatePrintTagData {
  name: string
  notes?: string
}

export interface DropdownPrintTag {
  id: number
  name: string
  items_count: number
}

export interface Tag {
  id: number
  contract_code: string
  contract_title: string
  tag_date: string
  created_by: string
  status: 'draft' | 'finalized'
  created_at: string
  finalized_at?: string
  file_path?: string
  notes?: string
  items_count: number
}

export interface TagItem {
  id: number
  asset_uid: string
  asset_name: string
  asset_type: string
  serial: string
  note?: string
  added_at: string
}

export interface CreateTagData {
  contract_code: string
  tag_date: string
  notes?: string
}

export interface RegistrySearchResult {
  score: number
  name: string
  type_si: string
  mit_number: string
  recommended_performer?: string
  estimated_external_cost?: number | null
  recommended_lead_days?: number | null
  cost_min?: number | null
  cost_max?: number | null
  avg_lead_days?: number | null
  lead_days_min?: number | null
  lead_days_max?: number | null
  records_count: number
  years: number[]
  sample_serial?: string
  sample_asset_uid?: string
  top_performers?: Array<{ performer: string; count: number }>
  performer_options?: Array<{
    performer: string
    external_cost?: number | null
    cost_min?: number | null
    cost_max?: number | null
    lead_days?: number | null
    lead_days_min?: number | null
    lead_days_max?: number | null
    records_count?: number
    date_sent?: string | null
    date_got?: string | null
    serial?: string
    year?: number
    latest_date?: string | null
  }>
  examples?: Array<{
    performer: string
    external_cost?: number | null
    date_sent?: string | null
    date_got?: string | null
    lead_days?: number | null
    serial?: string
    year?: number
  }>
}

export interface DistributionTab {
  id: number
  title: string
  status: 'draft' | 'archived'
  created_by: string
  notes?: string | null
  year?: number | null
  created_at: string
  updated_at: string
  items_count: number
  source_files?: string[]
}

export interface DistributionItem {
  id: number
  tab_id: number
  source_kind: 'scan' | 'manual'
  item_order?: number | null
  in_name: string
  in_type?: string | null
  in_serial?: string | null
  quantity: number
  raw_context?: string | null
  matched: number | boolean
  matched_asset_uid?: string | null
  contract_name?: string | null
  contract_type?: string | null
  contract_serial?: string | null
  performer?: string | null
  score: number
  confidence: string
  ambiguous: number | boolean
  estimated_external_cost?: number | null
}

export interface AppNotification {
  id: number
  kind: string
  severity: 'info' | 'warning' | 'critical'
  title: string
  message: string
  status: string
  job_id?: number | null
  request_id?: number | null
  service_request_id?: number | null
  read_at?: string | null
  done_at?: string | null
  created_at: string
  updated_at: string
}

export interface NotificationSetting {
  email: string
  name: string
  role: string
  enabled: boolean
  updated_by?: string | null
  updated_at?: string | null
}

export interface CustomerThread {
  customer_label?: string
  id: number
  contract_code: string
  contract_title: string
  contract_year?: number
  asset_uid?: string | null
  asset_name?: string | null
  asset_serial?: string | null
  customer_email: string
  subject: string
  status: string
  last_message?: string
  last_author_type?: 'customer' | 'staff'
  unread?: number
  created_at: string
  updated_at: string
  messages?: CustomerMessage[]
}

export interface CustomerMessage {
  id: number
  author_type: 'customer' | 'staff'
  author_email: string
  author_name: string
  body: string
  created_at: string
  attachments: Array<{ id: number; original_name: string; mime_type?: string; size: number }>
}

export interface CustomerRequestItemInput {
  asset_uid?: string
  name: string
  type_si?: string
  mit_number?: string
  serial?: string
  quantity: number
  work_types: string[]
  is_standard: boolean
  current_rank?: string
  rank_change: 'none' | 'up' | 'down'
  target_rank?: string
  verification_order?: string
  previous_fgis_number?: string
}

export interface ContractCatalogItem {
  id: number
  name: string
  type_si?: string
  mit_number?: string
  serial?: string
  quantity: number
  received: number | boolean
}

export interface CustomerRequestSummary {
  customer_label?: string
  id: number
  contract_code: string
  contract_title: string
  customer_email: string
  request_date: string
  comment?: string
  status: string
  status_message?: string | null
  status_updated_at?: string | null
  items_count: number
  created_at: string
  attachments?: Array<{ id: number; original_name: string; mime_type?: string; size: number }>
  items?: CustomerRequestItemInput[]
  events?: Array<{
    id?: number
    status: string
    message?: string | null
    author_name?: string | null
    author_type?: 'staff' | 'customer'
    created_at: string
  }>
}

export interface CustomerWorkspace {
  email?: string | null
  account: CustomerAccount
  contracts: Contract[]
  threads: CustomerThread[]
  requests: CustomerRequestSummary[]
  service_requests?: PublicServiceRequestSummary[]
}

export interface CustomerAccount {
  id: number
  login: string
  email?: string | null
  name?: string | null
  password?: string | null
  is_active: boolean
  must_change_password: boolean
  last_login_at?: string | null
  owners?: Array<{ id: number; name: string }>
  contracts?: Contract[]
}

export interface CustomerCredential {
  account_id: number
  owner_id?: number
  company: string
  login: string
  temporary_password: string
  email?: string | null
}

export interface CustomerContractAssignment extends Contract {
  assigned_account_id?: number | null
}

export interface ServiceEstimate {
  record_count: number
  years: number[]
  unit_median: number
  unit_p25: number
  unit_p75: number
  lead_days?: number | null
  lead_days_p25?: number | null
  lead_days_p75?: number | null
}

export interface ServiceEstimateResult {
  score: number
  name: string
  type_si?: string
  mit_number?: string
  estimate?: ServiceEstimate | null
}

export interface ImportedItemsResponse {
  filename: string
  source_type?: string
  /** Позиции распознаны по скану/фото: их нужно проверить перед отправкой. */
  needs_review?: boolean
  items_count: number
  items: ImportedRequestItem[]
}

export interface ImportedRequestItem {
  name: string
  type_si: string
  mit_number: string
  serial: string
  quantity: number
}

export interface PublicServiceRequestItem {
  id?: number
  name: string
  type_si?: string
  mit_number?: string
  serial?: string
  quantity: number
  package_count?: number
  note?: string
  work_types: string[] | string
  is_standard: boolean | number
  current_rank?: string
  target_rank?: string
  estimate_snapshot?: ServiceEstimate | string | null
  manager_unit_price?: number | null
  manager_price_min?: number | null
  manager_price_max?: number | null
  manager_lead_days?: number | null
  manager_note?: string | null
  clarification_question?: string | null
  components?: PublicServiceRequestComponent[]
}

export interface PublicServiceRequestComponent {
  id?: number
  name: string
  type_si?: string
  mit_number?: string
  serial?: string
  quantity: number
  package_count?: number
  note?: string
  work_types: string[] | string
  is_standard: boolean | number
  current_rank?: string
  target_rank?: string
  manager_unit_price?: number | null
  manager_price_min?: number | null
  manager_price_max?: number | null
  manager_lead_days?: number | null
  manager_note?: string | null
}

export interface GuestAccount {
  id: number
  email: string
  name: string
  must_change_password: boolean
}

export interface GuestAccountAdmin {
  id: number
  email: string
  phone?: string
  name?: string
  company_name?: string
  requests_count: number
  last_request_at?: string
  last_login_at?: string
  password_sent_at?: string
  is_active: boolean
  state: string
  forgot_pending: number
}

export interface PublicServiceRequestSummary {
  id: number
  kind: 'work_request' | 'commercial_offer'
  contract_number?: string | null
  contract_match_status: 'matched' | 'not_found' | 'not_provided'
  matched_contract_code?: string | null
  matched_contract_title?: string | null
  company_name: string
  inn?: string
  kpp?: string
  legal_address?: string
  postal_address?: string
  contact_name?: string
  customer_email: string
  contact_phone?: string
  comment?: string
  status: string
  status_message?: string | null
  status_updated_at?: string | null
  items_count: number
  created_at: string
  attachments?: Array<{ id: number; role: string; original_name: string; mime_type?: string; size: number }>
  items?: PublicServiceRequestItem[]
  events?: Array<{
    id?: number
    status: string
    message?: string | null
    author_name?: string | null
    created_at: string
  }>
}

export interface ExecutorInvoiceJob {
  id: number
  year: number
  contract_code: string
  contract_title: string
  performer?: string | null
  invoice_number: string
  invoice_date?: string | null
  invoice_raw?: string | null
  asset_count: number
  status: 'pending' | 'matched' | 'ambiguous' | 'not_found' | 'done'
  matched_request_id?: number | null
  match_score?: number | null
  matched_items?: number | null
  updated_at: string
  last_checked_at?: string | null
}

export interface ExecutorRequestDetails {
  request: {
    id: number
    request_number?: string | null
    performer?: string | null
    contract_hint?: string | null
    title?: string | null
    file_name?: string | null
    disk_path?: string | null
  }
  items: Array<{
    id: number
    serial?: string | null
    type_si?: string | null
    name?: string | null
    raw_context?: string | null
  }>
}

export interface AssetExecutorRequestStatus {
  has_invoice: boolean
  message?: string
  invoice_number?: string
  invoice_date?: string
  invoice_raw?: string
  module_enabled?: boolean
  job?: {
    id: number
    status: string
    matched_request_id?: number | null
    matched_items?: number | null
    asset_count?: number | null
  } | null
  request?: {
    id: number
    request_number?: string | null
    performer?: string | null
    file_name?: string | null
  } | null
}

// Р¤СѓРЅРєС†РёСЏ РґР»СЏ РїРѕР»СѓС‡РµРЅРёСЏ РіРѕРґР° РёР· localStorage
function getCurrentYear(): number | null {
  const saved = localStorage.getItem('selected_year')
  if (/^20\d{2}$/.test(saved || '')) {
    return Number(saved)
  }
  return null
}

// Р¤СѓРЅРєС†РёСЏ РґР»СЏ РґРѕР±Р°РІР»РµРЅРёСЏ РїР°СЂР°РјРµС‚СЂР° year Рє URL
function addYearParam(url: string, year?: number | null): string {
  const currentYear = year ?? getCurrentYear()
  if (currentYear) {
    const separator = url.includes('?') ? '&' : '?'
    return `${url}${separator}year=${currentYear}`
  }
  return url
}

// API РєР»РёРµРЅС‚
class ApiClient {
  private baseUrl: string
  private refreshPromise: Promise<string | null> | null = null

  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl
  }

  getAvailableYears = async (): Promise<{ years: number[] }> => {
    return this.request<{ years: number[] }>('/years')
  }

  private clearExpiredSession(): void {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('authorized_user')
    window.dispatchEvent(new CustomEvent('auth:session-expired'))
  }

  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`
    
    // РџРѕР»СѓС‡Р°РµРј С‚РѕРєРµРЅ Р°РІС‚РѕСЂРёР·Р°С†РёРё РёР· localStorage
    const authToken: string | null = null
    
    // РћС‚Р»Р°РґРѕС‡РЅР°СЏ РёРЅС„РѕСЂРјР°С†РёСЏ (С‚РѕР»СЊРєРѕ РІ development)
    if (import.meta.env.MODE === 'development') {
      console.log('API: Р—Р°РїСЂРѕСЃ Рє', url, {
        hasToken: !!authToken,
        tokenPreview: authToken ? authToken.substring(0, 50) + '...' : 'none'
      })
    }
    
    // Р•СЃР»Рё РµСЃС‚СЊ С‚РѕРєРµРЅ, СѓСЃС‚Р°РЅР°РІР»РёРІР°РµРј РµРіРѕ РєР°Рє cookie
    if (authToken) {
      // Р’ development СЂРµР¶РёРјРµ РЅРµ РёСЃРїРѕР»СЊР·СѓРµРј secure С„Р»Р°Рі
      const isDevelopment = import.meta.env.MODE === 'development'
      const cookieOptions = isDevelopment 
        ? `auth_token=${authToken}; path=/; samesite=lax`
        : `auth_token=${authToken}; path=/; secure; samesite=lax`
    }
    const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData

    const config: RequestInit = {
      credentials: 'include', // Р’РєР»СЋС‡Р°РµРј cookies
      headers: {
        ...(!isFormData && { 'Content-Type': 'application/json' }),
        // РџСЂРѕР±СѓРµРј Рё Р·Р°РіРѕР»РѕРІРѕРє, Рё cookie
        ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
        ...options.headers,
      },
      ...options,
    }

    const response = await fetch(url, config)
    
    if (!response.ok) {
      if (response.status === 401) {
        if (authToken && endpoint !== '/auth/login') {
          this.clearExpiredSession()
        }
        // Единый вход: сессия закончилась посреди работы. Проверка при загрузке страницы (me-cookie, gate-config)
        // сюда не относится: её 401 обрабатывает ProtectedRoute.
        const loginUrl = response.headers.get('X-Login-URL')
        if (loginUrl && !endpoint.startsWith('/auth/')) handleSessionLost(loginUrl)
        // РќРµ РїРµСЂРµРЅР°РїСЂР°РІР»СЏРµРј Р°РІС‚РѕРјР°С‚РёС‡РµСЃРєРё - РїСѓСЃС‚СЊ React Router СЃР°Рј РѕР±СЂР°Р±РѕС‚Р°РµС‚
        const unauthorized = await response.json().catch(() => null)
        throw new Error(unauthorized?.detail || 'Unauthorized')
      }
      const error = await response.json().catch(() => ({ detail: 'Unknown error' }))
      if (error.detail && typeof error.detail === 'object' && typeof error.detail.code === 'string') {
        throw new GateAccessError(String(error.detail.message || 'Нет доступа'), error.detail.code)
      }
      throw new Error(error.detail || `HTTP error! status: ${response.status}`)
    }

    return response.json()
  }

  private async requestBlob(endpoint: string, options: RequestInit = {}): Promise<{ blob: Blob; filename?: string }> {
    const authToken: string | null = null
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      credentials: 'include',
      ...options,
      headers: {
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
        ...options.headers,
      },
    })
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Ошибка скачивания' }))
      throw new Error(error.detail || `HTTP error! status: ${response.status}`)
    }
    const disposition = response.headers.get('content-disposition') || ''
    const encoded = disposition.match(/filename\*=utf-8''([^;]+)/i)?.[1]
    const plain = disposition.match(/filename="?([^";]+)"?/i)?.[1]
    return {
      blob: await response.blob(),
      filename: encoded ? decodeURIComponent(encoded) : plain,
    }
  }

  // РђСѓС‚РµРЅС‚РёС„РёРєР°С†РёСЏ
  login = async (username: string, password: string): Promise<User> => {
    console.log('API: Starting login request to:', `${this.baseUrl}/auth/login`)
    
    const formData = new FormData()
    formData.append('username', username)
    formData.append('password', password)

    try {
      const response = await fetch(`${this.baseUrl}/auth/login`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      })

      console.log('API: Login response status:', response.status)
      console.log('API: Login response headers:', Object.fromEntries(response.headers.entries()))

      if (!response.ok) {
        const errorText = await response.text()
        console.error('API: Login failed with status:', response.status, 'Error:', errorText)
        throw new Error(`Login failed: ${response.status} - ${errorText}`)
      }

      const userData = await response.json()
      console.log('API: Login successful, user data:', userData)
      
      // РЎРѕС…СЂР°РЅСЏРµРј РґР°РЅРЅС‹Рµ РїРѕР»СЊР·РѕРІР°С‚РµР»СЏ РІ localStorage РґР»СЏ Р·Р°РїРѕРјРёРЅР°РЅРёСЏ
      localStorage.setItem('user_data', JSON.stringify(userData))
      localStorage.setItem('login_timestamp', Date.now().toString())
      
      return userData
    } catch (error) {
      console.error('API: Login request error:', error)
      throw error
    }
  }


  // РљРѕРЅС‚СЂР°РєС‚С‹
  getContracts = async (year?: number, division?: 'lmo3' | 'spb'): Promise<Contract[]> => {
    console.log('API: Р—Р°РїСЂРѕСЃ РЅР° РїРѕР»СѓС‡РµРЅРёРµ РєРѕРЅС‚СЂР°РєС‚РѕРІ', { year })
    const params = new URLSearchParams()
    if (year !== undefined) params.set('year', String(year))
    if (division) params.set('division', division)
    const query = params.toString()
    const url = `/contracts${query ? `?${query}` : ''}`
    const response = await this.request<{ contracts: Contract[] }>(url)
    console.log('API: РћС‚РІРµС‚ СЃ РєРѕРЅС‚СЂР°РєС‚Р°РјРё:', response)
    return response.contracts
  }

  getContractStats = async (contractCode: string, year?: number): Promise<ContractStats> => {
    const encodedCode = encodeURIComponent(contractCode);
    console.log('API: getContractStats - original:', contractCode, 'encoded:', encodedCode);
    try {
      const response = await this.request<ContractStats>(addYearParam(`/contracts/${encodedCode}/stats`, year))
      console.log('API: getContractStats response:', response);
      return response
    } catch (error) {
      console.error('API: getContractStats error:', error);
      throw error;
    }
  }

  searchContractsByOwner = async (ownerName: string): Promise<{ contracts: Contract[] }> => {
    const encodedName = encodeURIComponent(ownerName);
    console.log('API: searchContractsByOwner - original:', ownerName, 'encoded:', encodedName);
    try {
      const response = await this.request<{ contracts: Contract[] }>(`/contracts/search?owner_name=${encodedName}`)
      console.log('API: searchContractsByOwner response:', response);
      return response
    } catch (error) {
      console.error('API: searchContractsByOwner error:', error);
      throw error;
    }
  }

  getContractTabs = async (
    contractCode: string,
    tab: 'in_work' | 'ready' | 'issued',
    page: number = 1,
    pageSize: number = 20
  ): Promise<ContractTabsResponse> => {
    const encodedCode = encodeURIComponent(contractCode);
    const params = new URLSearchParams({
      tab,
      page: page.toString(),
      page_size: pageSize.toString(),
    })
    
    return this.request<ContractTabsResponse>(
      `/contracts/${encodedCode}/tabs?${params}`
    )
  }

  // РђРєС‚РёРІС‹
  getLogistics = async (year?: number): Promise<LogisticsSummary> => {
    const params = new URLSearchParams()
    const currentYear = year ?? getCurrentYear()
    if (currentYear) params.append('year', currentYear.toString())
    return this.request<LogisticsSummary>(`/logistics?${params}`)
  }

  getAssets = async (
    contractCode?: string,
    query?: string,
    includeInactive: boolean = false,
    year?: number,
    division?: 'lmo3' | 'spb'
  ): Promise<Asset[]> => {
    const params = new URLSearchParams()
    if (contractCode) params.append('contract_code', contractCode)
    if (query) params.append('q', query)
    if (includeInactive) params.append('include_inactive', 'true')
    const currentYear = year ?? getCurrentYear()
    if (currentYear) params.append('year', currentYear.toString())
    if (division) params.append('division', division)

    const response = await this.request<{ assets: Asset[] }>(
      `/assets?${params}`
    )
    return response.assets
  }

  getAllAssets = async (): Promise<Asset[]> => {
    const response = await this.request<{ assets: Asset[] }>('/assets')
    return response.assets
  }

  getAsset = async (assetUid: string, year?: number): Promise<Asset> => {
    const url = addYearParam(`/assets/${assetUid}`, year)
    const response = await this.request<{ asset: Asset }>(url)
    return response.asset
  }

  updateAssetStatus = async (
    assetUid: string,
    status: string,
    note?: string
  ): Promise<void> => {
    await this.request(`/assets/${assetUid}/status`, {
      method: 'POST',
      body: JSON.stringify({ status, note }),
    })
  }

  // РСЃРїРѕР»РЅРёС‚РµР»Рё
  getAssetInspector = async (assetUid: string): Promise<{ inspector: string | null }> => {
    return this.request<{ inspector: string | null }>(`/assets/${assetUid}/inspector`)
  }

  updateAssetInspector = async (assetUid: string, inspector: string): Promise<void> => {
    const formData = new FormData()
    formData.append('inspector', inspector)

    await fetch(`${this.baseUrl}/assets/${assetUid}/inspector`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })
  }

  // РџРѕР»РєРё
  updateAssetShelf = async (assetUid: string, shelfLocation: string | null, year?: number): Promise<{ success: boolean; message: string; shelf_location: string | null }> => {
    const params = year ? `?year=${year}` : ''
    return this.request<{ success: boolean; message: string; shelf_location: string | null }>(`/assets/${assetUid}/shelf${params}`, {
      method: 'POST',
      body: JSON.stringify({ shelf_location: shelfLocation }),
    })
  }

  getAllShelves = async (year?: number): Promise<{ shelves: string[]; stats: Record<string, number> }> => {
    const params = year ? `?year=${year}` : ''
    return this.request<{ shelves: string[]; stats: Record<string, number> }>(`/shelves${params}`)
  }

  getShelfAssets = async (shelfLocation: string, year?: number): Promise<{ shelf_location: string; assets: Asset[]; count: number }> => {
    const params = year ? `?year=${year}` : ''
    return this.request<{ shelf_location: string; assets: Asset[]; count: number }>(`/shelves/${encodeURIComponent(shelfLocation)}/assets${params}`)
  }

  getBulkShelfAssets = async (shelves: string[], year?: number): Promise<BulkShelfAssetsResponse> => {
    return this.request<BulkShelfAssetsResponse>(`/shelves/assets/bulk`, {
      method: 'POST',
      body: JSON.stringify({ shelves, year }),
    })
  }

  // Chat
  getChatEmployees = async (): Promise<{ employees: EmployeeInfo[] }> => {
    return this.request<{ employees: EmployeeInfo[] }>('/chat/employees')
  }

  listChatSessions = async (): Promise<{ sessions: ChatSession[] }> => {
    return this.request<{ sessions: ChatSession[] }>('/chat/sessions')
  }

  listChatModels = async (): Promise<{ models: ChatModel[] }> => {
    return this.request<{ models: ChatModel[] }>('/chat/models')
  }

  getLatestDesktopRelease = async (): Promise<{ release: DesktopRelease }> => {
    return this.request<{ release: DesktopRelease }>('/desktop/releases/windows/latest')
  }

  getLatestPlatformReleases = async (): Promise<{ releases: { stable: PlatformRelease; preview: PlatformRelease } }> => {
    return this.request<{ releases: { stable: PlatformRelease; preview: PlatformRelease } }>('/desktop/releases/latest')
  }

  createDesktopLinkCode = async (): Promise<{ email: string; code: string; expires_in: number }> => {
    return this.request<{ email: string; code: string; expires_in: number }>('/desktop/auth/link-code', { method: 'POST' })
  }

  createChatSession = async (payload?: { title?: string; consultant_mode?: boolean; system_prompt?: string; model_id?: string }): Promise<{ session: ChatSession }> => {
    return this.request<{ session: ChatSession }>('/chat/sessions', {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    })
  }

  updateChatSession = async (
    sessionId: number,
    payload: { title?: string; consultant_mode?: boolean; system_prompt?: string; model_id?: string }
  ): Promise<{ session: ChatSession }> => {
    return this.request<{ session: ChatSession }>(`/chat/sessions/${sessionId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    })
  }

  deleteChatSession = async (sessionId: number): Promise<{ success: boolean }> => {
    return this.request<{ success: boolean }>(`/chat/sessions/${sessionId}`, {
      method: 'DELETE',
    })
  }

  getChatMessages = async (sessionId: number): Promise<{ messages: ChatMessage[] }> => {
    return this.request<{ messages: ChatMessage[] }>(`/chat/sessions/${sessionId}/messages`)
  }

  sendChatMessage = async (
    sessionId: number,
    message: string,
    max_history_messages: number = 30,
    year?: number
  ): Promise<{ answer: string; messages: ChatMessage[]; rag?: { items: any[]; context: string }; tools?: any[] }> => {
    return this.request<{ answer: string; messages: ChatMessage[]; rag?: { items: any[]; context: string }; tools?: any[] }>(`/chat/sessions/${sessionId}/messages`, {
      method: 'POST',
      body: JSON.stringify({ message, max_history_messages, year }),
    })
  }

  clearChatMessages = async (sessionId: number): Promise<{ success: boolean }> => {
    return this.request<{ success: boolean }>(`/chat/sessions/${sessionId}/clear`, {
      method: 'POST',
    })
  }

  shareChatSession = async (sessionId: number, email: string): Promise<{ success: boolean; session: ChatSession }> => {
    return this.request<{ success: boolean; session: ChatSession }>(`/chat/sessions/${sessionId}/share`, {
      method: 'POST',
      body: JSON.stringify({ email }),
    })
  }

  unshareChatSession = async (sessionId: number, email: string): Promise<{ success: boolean; session: ChatSession }> => {
    return this.request<{ success: boolean; session: ChatSession }>(`/chat/sessions/${sessionId}/share/${encodeURIComponent(email)}`, {
      method: 'DELETE',
    })
  }

  createRagFeedbackReport = async (payload: {
    session_id?: number
    query_text: string
    response_text?: string
    fif_hint?: string
    si_type_hint?: string
    notes?: string
  }): Promise<{ success: boolean; report_id: number }> => {
    return this.request<{ success: boolean; report_id: number }>(`/chat/rag-feedback`, {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  }

  createEmployeeFeedback = async (
    payload: {
      category: EmployeeFeedbackCategory
      subject: string
      body: string
      page_url: string
      user_agent: string
    },
    attachments: File[] = []
  ): Promise<{ success: boolean; feedback_id: number }> => {
    const form = new FormData()
    Object.entries(payload).forEach(([key, value]) => form.append(key, value))
    attachments.forEach((file) => form.append('attachments', file))
    return this.request('/feedback', { method: 'POST', body: form })
  }

  listEmployeeFeedback = async (): Promise<{ feedback: EmployeeFeedback[] }> => {
    return this.request('/feedback')
  }

  updateEmployeeFeedback = async (
    id: number,
    payload: { status: EmployeeFeedbackStatus; admin_note?: string }
  ): Promise<{ feedback: EmployeeFeedback }> => {
    return this.request(`/feedback/${id}`, { method: 'PATCH', body: JSON.stringify(payload) })
  }

  downloadEmployeeFeedbackAttachment = async (
    feedbackId: number,
    attachmentId: number
  ): Promise<{ blob: Blob; filename: string }> => {
    const authToken: string | null = null
    const response = await fetch(`${this.baseUrl}/feedback/${feedbackId}/attachments/${attachmentId}`, {
      credentials: 'include',
      headers: { ...(authToken && { Authorization: `Bearer ${authToken}` }) },
    })
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Не удалось скачать вложение' }))
      throw new Error(error.detail || `HTTP error! status: ${response.status}`)
    }
    const disposition = response.headers.get('content-disposition') || ''
    const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i)
    return {
      blob: await response.blob(),
      filename: match ? decodeURIComponent(match[1].replace(/"/g, '')) : `attachment-${attachmentId}`,
    }
  }

  listRagFeedbackReports = async (): Promise<{ reports: RagFeedbackReport[] }> => {
    return this.request<{ reports: RagFeedbackReport[] }>(`/chat/rag-feedback`)
  }

  clearShelf = async (shelfLocation: string, year?: number): Promise<{ success: boolean; message: string; cleared_count: number }> => {
    const params = year ? `?year=${year}` : ''
    return this.request<{ success: boolean; message: string; cleared_count: number }>(`/shelves/${encodeURIComponent(shelfLocation)}${params}`, {
      method: 'DELETE',
    })
  }

  // РЈРїСЂР°РІР»РµРЅРёРµ РїРѕР»РєР°РјРё
  createShelf = async (name: string, description?: string, year?: number): Promise<{ success: boolean; message: string; shelf: any }> => {
    const params = year ? `?year=${year}` : ''
    return this.request<{ success: boolean; message: string; shelf: any }>(`/shelves/create${params}`, {
      method: 'POST',
      body: JSON.stringify({ name, description }),
    })
  }

  getShelvesList = async (year?: number): Promise<{ shelves: Array<{ id: number; name: string; description?: string; assets_count: number }>; stats: Record<string, number> }> => {
    const params = year ? `?year=${year}` : ''
    return this.request<{ shelves: Array<{ id: number; name: string; description?: string; assets_count: number }>; stats: Record<string, number> }>(`/shelves/list${params}`)
  }

  updateShelf = async (shelfId: number, name?: string, description?: string): Promise<{ success: boolean; message: string; shelf: any }> => {
    return this.request<{ success: boolean; message: string; shelf: any }>(`/shelves/${shelfId}`, {
      method: 'PUT',
      body: JSON.stringify({ name, description }),
    })
  }

  deleteShelf = async (shelfId: number): Promise<{ success: boolean; message: string }> => {
    return this.request<{ success: boolean; message: string }>(`/shelves/delete/${shelfId}`, {
      method: 'DELETE',
    })
  }

  // Р¤РѕС‚РѕРіСЂР°С„РёРё
  getAssetPhotos = async (assetUid: string): Promise<AssetPhotosByKind> => {
    const response = await this.request<{ photos: AssetPhotosByKind }>(
      `/assets/${assetUid}/photos`
    )
    
    // Р”РѕР±Р°РІР»СЏРµРј РїСЂР°РІРёР»СЊРЅС‹Рµ URL РґР»СЏ С„РѕС‚Рѕ
    const photos = response.photos
    for (const kind in photos) {
      photos[kind] = photos[kind].map(photo => ({
        ...photo,
        url: photo.source === 'yandex_disk' && photo.url
          ? photo.url
          : `/media/${(photo.file_path || '').replace('app/media/', '')}`,
        thumb_url: photo.source === 'yandex_disk' && photo.thumb_url
          ? photo.thumb_url
          : photo.thumb_path
            ? `/media/${photo.thumb_path.replace('app/media/', '')}`
            : `/media/${(photo.file_path || '').replace('app/media/', '')}`
      }))
    }
    
    return photos
  }

  uploadAssetPhotos = async (
    assetUid: string,
    files: File[],
    kind: string,
    note?: string
  ): Promise<{ message: string; photos: AssetPhoto[] }> => {
    const formData = new FormData()
    files.forEach(file => formData.append('files', file))
    formData.append('kind', kind)
    if (note) formData.append('note', note)

    const response = await fetch(`${this.baseUrl}/assets/${assetUid}/photos`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`Upload failed: ${response.status} - ${errorText}`)
    }

    return response.json()
  }

  deleteAssetPhoto = async (assetUid: string, photoId: number): Promise<void> => {
    await this.request(`/assets/${assetUid}/photos/${photoId}`, {
      method: 'DELETE',
    })
  }

  scanAcceptancePhotos = async (payload: {
    date: string
    disk_folder?: string
    location_hint?: string
    limit?: number
    scan_max?: number
    source?: 'folder' | 'last-uploaded'
  }): Promise<{ batch_id?: number | null; batch_ids?: number[]; locations?: string[]; indexed: number; added?: number; skipped: number; date: string; disk_folder: string }> => {
    return this.request<{ batch_id?: number | null; batch_ids?: number[]; locations?: string[]; indexed: number; added?: number; skipped: number; date: string; disk_folder: string }>(
      '/acceptance-photos/scan',
      {
        method: 'POST',
        body: JSON.stringify(payload),
      }
    )
  }

  getAcceptancePhotoBatches = async (limit: number = 30): Promise<{ batches: PhotoBatch[] }> => {
    return this.request<{ batches: PhotoBatch[] }>(`/acceptance-photos/batches?limit=${limit}`)
  }

  getVaultTree = async (division?: string, contract?: string): Promise<VaultTreeResponse> => {
    const params = new URLSearchParams()
    if (division) params.set('division', division)
    if (contract) params.set('contract', contract)
    return this.request<VaultTreeResponse>(`/acceptance-photos/vault/tree?${params.toString()}`)
  }

  scanVaultAcceptancePhotos = async (payload: {
    division: string
    contract: string
    date: string
  }): Promise<{ ok: boolean; indexed: number; added: number; skipped: number; date: string; division: string; contract?: string; message?: string }> => {
    return this.request('/acceptance-photos/scan-vault', {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  }

  getAcceptancePhotoWorkspace = async (
    contractCode: string,
    options?: {
      date?: string
      batchId?: number
      assetDate?: string
      year?: number
      locationHint?: string
    }
  ): Promise<AcceptancePhotoWorkspace> => {
    const params = new URLSearchParams()
    params.set('contract_code', contractCode)
    if (options?.date) params.set('date', options.date)
    if (options?.batchId) params.set('batch_id', String(options.batchId))
    if (options?.assetDate) params.set('asset_date', options.assetDate)
    const currentYear = options?.year ?? getCurrentYear()
    if (currentYear) params.set('year', String(currentYear))
    if (options?.locationHint) params.set('location_hint', options.locationHint)
    return this.request<AcceptancePhotoWorkspace>(`/acceptance-photos/workspace?${params.toString()}`)
  }

  linkAcceptancePhotos = async (payload: {
    asset_uids: string[]
    photo_ids: number[]
    kind: string
    note?: string
  }): Promise<{ success: boolean; linked: number }> => {
    return this.request<{ success: boolean; linked: number }>('/acceptance-photos/link', {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  }

  bulkLinkAcceptancePhotos = async (payload: {
    links: AcceptancePhotoLinkItem[]
    kind: string
    note?: string
  }): Promise<{ success: boolean; linked: number }> => {
    return this.request<{ success: boolean; linked: number }>('/acceptance-photos/link-bulk', {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  }

  unlinkAcceptancePhotos = async (payload: {
    links: AcceptancePhotoLinkItem[]
    kind?: string
  }): Promise<{ success: boolean; unlinked: number }> => {
    return this.request<{ success: boolean; unlinked: number }>('/acceptance-photos/unlink', {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  }

  // Р¤Р“РРЎ РђСЂС€РёРЅ
  getAssetFGISCheck = async (assetUid: string): Promise<FGISCheck> => {
    return this.request<FGISCheck>(`/assets/${assetUid}/fgis`)
  }

  checkAssetFgis = async (assetUid: string): Promise<{ success: boolean; message: string; verification?: any }> => {
    return this.request<{ success: boolean; message: string; verification?: any }>(`/assets/${assetUid}/fgis-check`, {
      method: 'POST'
    })
  }

  checkAssetFgisHistory = async (assetUid: string): Promise<{ success: boolean; message: string; history?: any[] }> => {
    return this.request<{ success: boolean; message: string; history?: any[] }>(`/assets/${assetUid}/fgis-history`, {
      method: 'POST'
    })
  }

  getAssetFgisHistory = async (assetUid: string): Promise<{ history: any[] }> => {
    return this.request<{ history: any[] }>(`/assets/${assetUid}/fgis-history`)
  }

  getAssetRostestCertificate = async (assetUid: string): Promise<{ certificate: RostestCertificate | null }> => {
    return this.request<{ certificate: RostestCertificate | null }>(`/assets/${assetUid}/rostest-certificate`)
  }

  // Заявление-квитанция (ЗК) Ростеста, найденная по номеру счёта прибора
  getAssetRostestStatement = async (assetUid: string): Promise<{ statement: RostestStatement | null; item?: RostestStatementItem | null }> => {
    return this.request(`/assets/${assetUid}/rostest-statement`)
  }

  checkAssetRostestStatement = async (assetUid: string): Promise<{ status: string; statement?: RostestStatement | null; item?: RostestStatementItem | null; reason?: string }> => {
    return this.request(`/assets/${assetUid}/rostest-statement/check`, { method: 'POST' })
  }

  checkAssetRostestCertificate = async (assetUid: string): Promise<{ status: string; certificate?: RostestCertificate | null; reason?: string }> => {
    return this.request(`/assets/${assetUid}/rostest-certificate/check`, { method: 'POST' })
  }

  // РџСѓР±Р»РёС‡РЅС‹Рµ РјРµС‚РѕРґС‹ РґР»СЏ Р·Р°РєР°Р·С‡РёРєРѕРІ (Р±РµР· Р°РІС‚РѕСЂРёР·Р°С†РёРё)
  getPublicAsset = async (assetUid: string): Promise<{ asset: Asset; access?: 'full' | 'limited' }> => {
    return this.request<{ asset: Asset; access?: 'full' | 'limited' }>(`/public/assets/${assetUid}`)
  }

  getPublicAssetPhotos = async (assetUid: string): Promise<{ photos: any }> => {
    return this.request<{ photos: any }>(`/public/assets/${assetUid}/photos`)
  }

  getPublicAssetFgis = async (assetUid: string): Promise<{ fgis_info: any }> => {
    return this.request<{ fgis_info: any }>(`/public/assets/${assetUid}/fgis`)
  }

  getPublicAssetFgisHistory = async (assetUid: string): Promise<{ history: any[] }> => {
    return this.request<{ history: any[] }>(`/public/assets/${assetUid}/fgis-history`)
  }

  getPublicAssetRostestCertificate = async (assetUid: string): Promise<{ certificate: RostestCertificate | null }> => {
    return this.request<{ certificate: RostestCertificate | null }>(`/public/assets/${assetUid}/rostest-certificate`)
  }

  customerLogin = async (login: string, password: string): Promise<{ account: CustomerAccount }> => {
    return this.request('/public/customer/auth/login', { method: 'POST', body: JSON.stringify({ login, password }) })
  }

  customerLogout = async (): Promise<{ success: boolean }> => this.request('/public/customer/auth/logout', { method: 'POST' })

  getCustomerAccount = async (): Promise<{ account: CustomerAccount }> => this.request('/public/customer/auth/me')

  changeCustomerPassword = async (currentPassword: string, newPassword: string): Promise<{ success: boolean }> => {
    return this.request('/public/customer/auth/change-password', { method: 'POST', body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }) })
  }

  forgotCustomerPassword = async (email: string): Promise<{ success: boolean; message: string }> => {
    return this.request('/public/customer/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) })
  }

  resetCustomerPassword = async (token: string, newPassword: string): Promise<{ success: boolean }> => {
    return this.request('/public/customer/auth/reset-password', { method: 'POST', body: JSON.stringify({ token, new_password: newPassword }) })
  }

  getCustomerWorkspace = async (_email?: string): Promise<CustomerWorkspace> => {
    return this.request<CustomerWorkspace>('/public/customer/workspace')
  }

  linkPublicCustomerContact = async (data: { email: string; name: string; contract_code: string; contract_year: number }): Promise<{ success: boolean; email: string }> => {
    return this.request('/public/customer/contacts/link', { method: 'POST', body: JSON.stringify(data) })
  }

  createCustomerThread = async (data: { contract_code: string; asset_uid?: string; email: string; subject: string; message: string }): Promise<{ id: number; message_id: number }> => {
    return this.request('/public/customer/threads', { method: 'POST', body: JSON.stringify(data) })
  }

  getCustomerThread = async (id: number, _email?: string): Promise<{ thread: CustomerThread }> => {
    return this.request(`/public/customer/threads/${id}`)
  }

  sendCustomerMessage = async (id: number, email: string, message: string): Promise<{ id: number }> => {
    return this.request(`/public/customer/threads/${id}/messages`, { method: 'POST', body: JSON.stringify({ email, message }) })
  }

  uploadCustomerMessageFiles = async (messageId: number, _email: string, files: File[]): Promise<any> => {
    const form = new FormData()
    files.forEach((file) => form.append('files', file))
    return this.request(`/public/customer/messages/${messageId}/attachments`, { method: 'POST', body: form })
  }

  searchCustomerRegistry = async (query: string): Promise<{ results: RegistrySearchResult[] }> => {
    return this.request(`/public/customer/registry/search?query=${encodeURIComponent(query)}`)
  }

  getCustomerContractCatalog = async (contractCode: string, _email: string, year?: number): Promise<{ contract: Contract; items: ContractCatalogItem[] }> => {
    const query = new URLSearchParams({ not_received_only: 'true' })
    if (year) query.set('year', String(year))
    return this.request(`/public/customer/contracts/${encodeURIComponent(contractCode)}/catalog?${query}`)
  }

  getCustomerContractAssets = async (contractCode: string, year?: number): Promise<Asset[]> => {
    const query = year ? `?year=${year}` : ''
    return this.request(`/public/customer/contracts/${encodeURIComponent(contractCode)}/assets${query}`)
  }

  searchPublicServiceEstimates = async (query: string, workTypes: string[]): Promise<{ results: ServiceEstimateResult[] }> => {
    const params = new URLSearchParams({ query, work_types: workTypes.join(',') })
    return this.request(`/public/service-estimates/search?${params.toString()}`)
  }

  importPublicServiceRequestItems = async (file: File): Promise<ImportedItemsResponse> => {
    const form = new FormData()
    form.append('file', file)
    return this.request('/public/service-requests/import-items', { method: 'POST', body: form })
  }

  createPublicServiceRequest = async (payload: unknown, organizationCard?: File | null, attachments: File[] = []): Promise<{ id: number; number: string; contract_match_status: string }> => {
    const form = new FormData()
    form.append('payload', JSON.stringify(payload))
    if (organizationCard) form.append('organization_card', organizationCard)
    attachments.forEach((file) => form.append('attachments', file))
    return this.request('/public/service-requests', { method: 'POST', body: form })
  }

  // Кабинет гостя «холодных» обращений: вход по почте и одноразовому паролю из письма.
  guestLogin = async (email: string, password: string): Promise<{ account: GuestAccount }> => {
    return this.request('/public/service-requests/account/login', { method: 'POST', body: JSON.stringify({ email, password }) })
  }

  guestLogout = async (): Promise<{ success: boolean }> => this.request('/public/service-requests/account/logout', { method: 'POST' })

  getGuestAccount = async (): Promise<{ account: GuestAccount }> => this.request('/public/service-requests/account/me')

  changeGuestPassword = async (newPassword: string, currentPassword = ''): Promise<{ success: boolean }> => {
    return this.request('/public/service-requests/account/change-password', {
      method: 'POST', body: JSON.stringify({ new_password: newPassword, current_password: currentPassword }),
    })
  }

  guestForgotPassword = async (email: string, phone: string, note: string): Promise<{ success: boolean; message: string }> => {
    return this.request('/public/service-requests/account/forgot', { method: 'POST', body: JSON.stringify({ email, phone, note }) })
  }

  getPublicServiceRequestHistory = async (): Promise<{ contact: string; requests: PublicServiceRequestSummary[] }> => {
    return this.request('/public/service-requests/history')
  }

  listGuestAccounts = async (): Promise<{ accounts: GuestAccountAdmin[]; forgot: Array<{ id: number; email: string; phone?: string; note?: string; created_at: string }>; smtp_configured: boolean }> => {
    return this.request('/customer-admin/guest-accounts')
  }

  sendGuestPassword = async (id: number): Promise<{ sent: boolean; email: string }> => {
    return this.request(`/customer-admin/guest-accounts/${id}/send-password`, { method: 'POST' })
  }

  createCustomerRequest = async (data: { contract_code: string; contract_year?: number; email: string; request_date: string; comment?: string; items: CustomerRequestItemInput[] }): Promise<{ id: number; docx_url: string; xlsx_url: string }> => {
    return this.request('/public/customer/requests', { method: 'POST', body: JSON.stringify(data) })
  }

  uploadCustomerRequestFiles = async (id: number, _email: string, files: File[]): Promise<any> => {
    const form = new FormData()
    files.forEach((file) => form.append('files', file))
    return this.request(`/public/customer/requests/${id}/attachments`, { method: 'POST', body: form })
  }

  // Список приборов уходит в теле POST: в query-строке сотни uid упирались в лимит длины URL (HTTP 414).
  // Скачивание идёт через requestBlob с cookie кабинета — обычный fetch(url) на другом origin их не передаёт.
  downloadCustomerReport = (contractCode: string, format: 'docx' | 'xlsx', params: { year?: number; status?: string; date_recv?: string; asset_uids?: string[] }) => {
    return this.requestBlob(`/public/customer/contracts/${encodeURIComponent(contractCode)}/report.${format}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...params, asset_uids: params.asset_uids || [] }),
    })
  }

  // Журнал СИ (только сотрудники)
  getJournalMeta = async (): Promise<JournalMeta> => this.request('/journal/meta')

  queryJournal = async (body: JournalQuery): Promise<JournalResult> => {
    return this.request('/journal/query', { method: 'POST', body: JSON.stringify(body) })
  }

  exportJournal = (body: JournalQuery, format: 'xlsx' | 'csv') => {
    return this.requestBlob('/journal/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...body, format }),
    })
  }

  queryJournalManualItems = async (body: ManualItemsQuery): Promise<ManualItemsResult> => {
    return this.request('/journal/manual-items', { method: 'POST', body: JSON.stringify(body) })
  }

  exportJournalManualItems = (body: ManualItemsQuery, format: 'xlsx' | 'csv') => {
    return this.requestBlob('/journal/manual-items/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...body, format }),
    })
  }
  getJournalTimeline = async (assetUid: string): Promise<JournalTimeline> => {
    return this.request(`/journal/assets/${encodeURIComponent(assetUid)}/timeline`)
  }

  listJournalViews = async (): Promise<{ views: JournalView[] }> => this.request('/journal/views')

  saveJournalView = async (name: string, config: JournalQuery): Promise<{ success: boolean }> => {
    return this.request('/journal/views', { method: 'POST', body: JSON.stringify({ name, config }) })
  }

  deleteJournalView = async (id: number): Promise<{ success: boolean }> => this.request(`/journal/views/${id}`, { method: 'DELETE' })

  downloadCustomerFullReport = (contractCode: string, year?: number) => {
    const query = year ? `?year=${year}` : ''
    return this.requestBlob(`/public/customer/contracts/${encodeURIComponent(contractCode)}/full-report.xlsx${query}`)
  }

  importCustomerRequestItems = async (file: File): Promise<ImportedItemsResponse> => {
    const form = new FormData()
    form.append('file', file)
    return this.request('/public/customer/requests/import-items', { method: 'POST', body: form })
  }

  getCustomerInbox = async (): Promise<{ threads: CustomerThread[]; requests: CustomerRequestSummary[]; service_requests: PublicServiceRequestSummary[]; notifications_enabled: boolean }> => {
    return this.request('/customer-admin/inbox')
  }

  updateCustomerRequest = async (id: number, data: { status: string; message?: string }): Promise<{ request: CustomerRequestSummary }> => {
    return this.request(`/customer-admin/requests/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    })
  }

  replyToCustomerRequest = async (id: number, email: string, message: string): Promise<{ success: boolean }> => {
    return this.request(`/public/customer/requests/${id}/reply`, {
      method: 'POST',
      body: JSON.stringify({ email, message }),
    })
  }

  getPublicServiceRequestDocumentUrl = (id: number, format: 'docx' | 'xlsx'): string => {
    return `${this.baseUrl}/customer-admin/service-requests/${id}/${format}`
  }

  downloadPublicServiceRequestDocument = async (id: number, format: 'docx' | 'xlsx'): Promise<{ blob: Blob; filename: string }> => {
    const url = this.getPublicServiceRequestDocumentUrl(id, format)
    const authToken: string | null = null
    const response = await fetch(url, {
      credentials: 'include',
      headers: { ...(authToken && { Authorization: `Bearer ${authToken}` }) },
    })
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Не удалось сформировать документ' }))
      throw new Error(error.detail || `HTTP error! status: ${response.status}`)
    }
    const blob = await response.blob()
    const contentDisposition = response.headers.get('content-disposition') || ''
    const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i)
    const filename = filenameMatch
      ? decodeURIComponent(filenameMatch[1].replace(/"/g, ''))
      : `service_request_${id}.${format}`
    return { blob, filename }
  }

  updatePublicServiceRequest = async (id: number, data: { status: string; message?: string }): Promise<{ request: PublicServiceRequestSummary }> => {
    return this.request(`/customer-admin/service-requests/${id}`, { method: 'PATCH', body: JSON.stringify(data) })
  }

  updatePublicServiceRequestItem = async (requestId: number, itemId: number, data: unknown): Promise<{ request: PublicServiceRequestSummary }> => {
    return this.request(`/customer-admin/service-requests/${requestId}/items/${itemId}`, { method: 'PATCH', body: JSON.stringify(data) })
  }

  replyToPublicServiceRequest = async (requestId: number, message: string): Promise<{ success: boolean }> => {
    return this.request(`/public/service-requests/${requestId}/reply`, { method: 'POST', body: JSON.stringify({ message }) })
  }

  getPublicServiceRequestAttachmentUrl = (requestId: number, attachmentId: number): string => {
    return `${this.baseUrl}/customer-admin/service-requests/${requestId}/attachments/${attachmentId}`
  }

  getStaffCustomerThread = async (id: number): Promise<{ thread: CustomerThread }> => {
    return this.request(`/customer-admin/threads/${id}`)
  }

  sendStaffCustomerMessage = async (id: number, message: string): Promise<{ id: number }> => {
    return this.request(`/customer-admin/threads/${id}/messages`, { method: 'POST', body: JSON.stringify({ message }) })
  }

  uploadStaffCustomerMessageFiles = async (messageId: number, files: File[]): Promise<any> => {
    const form = new FormData()
    files.forEach((file) => form.append('files', file))
    return this.request(`/customer-admin/messages/${messageId}/attachments`, { method: 'POST', body: form })
  }

  listCustomerContacts = async (): Promise<{ contacts: any[] }> => this.request('/customer-admin/contacts')

  saveCustomerContact = async (data: { email: string; name?: string; company?: string; contract_codes: string[] }): Promise<any> => {
    return this.request('/customer-admin/contacts', { method: 'PUT', body: JSON.stringify(data) })
  }

  listCustomerAccounts = async (): Promise<{ accounts: CustomerAccount[]; contracts: CustomerContractAssignment[] }> => this.request('/customer-admin/accounts')

  createCustomerAccount = async (data: { email?: string; name?: string; contract_ids: number[] }): Promise<{ account: CustomerAccount; credential: CustomerCredential }> => {
    return this.request('/customer-admin/accounts', { method: 'POST', body: JSON.stringify(data) })
  }

  saveCustomerAccount = async (id: number, data: { email?: string; name?: string; is_active: boolean; contract_ids: number[] }): Promise<{ account: CustomerAccount }> => {
    return this.request(`/customer-admin/accounts/${id}`, { method: 'PUT', body: JSON.stringify(data) })
  }

  resetCustomerTemporaryPassword = async (id: number): Promise<{ account: CustomerAccount; temporary_password: string }> => {
    return this.request(`/customer-admin/accounts/${id}/temporary-password`, { method: 'POST' })
  }

  // QR РєРѕРґС‹
  getAssetQRUrl = (assetUid: string): string => {
    return `${this.baseUrl}/assets/${assetUid}/qr.png`
  }

  // РљРѕРЅС‚СЂР°РєС‚С‹
  async getContractAssets(contractCode: string, year?: number): Promise<Asset[]> {
    const encodedCode = encodeURIComponent(contractCode);
    console.log('API: getContractAssets - original:', contractCode, 'encoded:', encodedCode, 'year:', year);
    try {
      const url = addYearParam(`/contracts/${encodedCode}/assets`, year)
      const response = await this.request<Asset[]>(url)
      console.log('API: getContractAssets response:', response);
      return response
    } catch (error) {
      console.error('API: getContractAssets error:', error);
      throw error;
    }
  }

  // Р”РѕРєСѓРјРµРЅС‚РѕРѕР±РѕСЂРѕС‚
  createShipmentAct = async (data: CreateShipmentActData): Promise<ShipmentAct> => {
    return this.request<ShipmentAct>('/docs/shipment', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  getShipmentActs = async (status: 'draft' | 'archived' = 'draft', mine: boolean = true): Promise<ShipmentAct[]> => {
    const params = new URLSearchParams({
      status,
      mine: mine.toString(),
    })
    return this.request<ShipmentAct[]>(`/docs/shipment?${params}`)
  }

  getNextShipmentActNumber = async (contractCode: string): Promise<NextDocumentNumber> => {
    const params = new URLSearchParams({ contract: contractCode })
    return this.request<NextDocumentNumber>(`/docs/shipment/next-number?${params}`)
  }

  getShipmentAct = async (actId: number): Promise<ShipmentAct> => {
    return this.request<ShipmentAct>(`/docs/shipment/${actId}`)
  }

  getShipmentActItems = async (actId: number): Promise<ShipmentActItem[]> => {
    return this.request<ShipmentActItem[]>(`/docs/shipment/${actId}/items`)
  }

  addShipmentActItem = async (actId: number, assetUid: string, category: string = 'default'): Promise<{ id: number; message: string }> => {
    return this.request<{ id: number; message: string }>(`/docs/shipment/${actId}/items`, {
      method: 'POST',
      body: JSON.stringify({ asset_uid: assetUid, category }),
    })
  }

  addManualShipmentActItem = async (actId: number, data: { serial: string; name: string; type_si: string }): Promise<{ id: number; message: string }> => {
    return this.request<{ id: number; message: string }>(`/docs/shipment/${actId}/items/manual`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  updateManualShipmentActItem = async (actId: number, itemId: number, data: { serial: string; name: string; type_si: string }): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/shipment/${actId}/items/${itemId}/manual`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  }
  removeShipmentActItem = async (actId: number, itemId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/shipment/${actId}/items/${itemId}`, {
      method: 'DELETE',
    })
  }

  updateShipmentActItemCategory = async (actId: number, itemId: number, category: string): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/shipment/${actId}/items/${itemId}/category`, {
      method: 'PUT',
      body: JSON.stringify({ category }),
    })
  }

  updateShipmentActItemRostestPdf = async (actId: number, itemId: number, include: boolean): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/shipment/${actId}/items/${itemId}/rostest-pdf`, {
      method: 'PUT',
      body: JSON.stringify({ include }),
    })
  }

  checkShipmentActRostestCertificates = async (actId: number): Promise<RostestDocumentJob> => {
    return this.request<RostestDocumentJob>(`/docs/shipment/${actId}/rostest-certificates/check`, { method: 'POST' })
  }

  finalizeShipmentAct = async (actId: number): Promise<{ file_url: string }> => {
    return this.request<{ file_url: string }>(`/docs/shipment/${actId}/finalize`, {
      method: 'POST',
    })
  }

  reopenShipmentAct = async (actId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/shipment/${actId}/reopen`, {
      method: 'POST',
    })
  }

  deleteShipmentAct = async (actId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/shipment/${actId}`, {
      method: 'DELETE',
    })
  }

  getShipmentActsForDropdown = async (contractCode?: string): Promise<DropdownAct[]> => {
    const params = new URLSearchParams()
    if (contractCode) {
      params.append('contract', contractCode)
    }
    const queryString = params.toString()
    return this.request<DropdownAct[]>(`/docs/shipment/for-dropdown${queryString ? `?${queryString}` : ''}`)
  }

  createSubcontractorApplication = async (data: {
    contract_id: number
    subcontractor_code?: string
    outgoing_number: string
    outgoing_date: string
  }): Promise<SubcontractorApplication> => {
    return this.request('/docs/subcontractor-applications', { method: 'POST', body: JSON.stringify(data) })
  }

  getSubcontractorTemplates = async (): Promise<SubcontractorTemplate[]> => {
    return this.request('/docs/subcontractor-applications/templates')
  }

  getSubcontractorApplications = async (status?: 'draft' | 'archived', contractId?: number): Promise<SubcontractorApplication[]> => {
    const params = new URLSearchParams()
    if (status) params.set('status', status)
    if (contractId) params.set('contract_id', String(contractId))
    const query = params.toString()
    return this.request(`/docs/subcontractor-applications${query ? `?${query}` : ''}`)
  }

  getSubcontractorApplicationsForDropdown = async (contractId: number): Promise<SubcontractorApplicationDropdown[]> => {
    return this.request(`/docs/subcontractor-applications/for-dropdown?contract_id=${contractId}`)
  }

  getSubcontractorApplication = async (id: number): Promise<SubcontractorApplication> => {
    return this.request(`/docs/subcontractor-applications/${id}`)
  }

  updateSubcontractorApplication = async (id: number, data: Partial<SubcontractorApplication>): Promise<SubcontractorApplication> => {
    return this.request(`/docs/subcontractor-applications/${id}`, { method: 'PUT', body: JSON.stringify(data) })
  }

  getSubcontractorApplicationItems = async (id: number): Promise<SubcontractorApplicationItem[]> => {
    return this.request(`/docs/subcontractor-applications/${id}/items`)
  }

  addSubcontractorApplicationItem = async (id: number, assetUid: string): Promise<{ id: number }> => {
    return this.request(`/docs/subcontractor-applications/${id}/items`, {
      method: 'POST', body: JSON.stringify({ asset_uid: assetUid }),
    })
  }

  updateSubcontractorApplicationItem = async (id: number, itemId: number, data: Partial<SubcontractorApplicationItem>): Promise<{ success: boolean }> => {
    return this.request(`/docs/subcontractor-applications/${id}/items/${itemId}`, {
      method: 'PUT', body: JSON.stringify(data),
    })
  }

  removeSubcontractorApplicationItem = async (id: number, itemId: number): Promise<{ success: boolean }> => {
    return this.request(`/docs/subcontractor-applications/${id}/items/${itemId}`, { method: 'DELETE' })
  }

  downloadSubcontractorApplication = async (
    id: number,
    fallbackName: string,
    data?: Partial<SubcontractorApplication>,
  ): Promise<void> => {
    const { blob, filename } = await this.requestBlob(`/docs/subcontractor-applications/${id}/download`, {
      method: 'POST',
      headers: data ? { 'Content-Type': 'application/json' } : undefined,
      body: data ? JSON.stringify(data) : undefined,
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename || fallbackName
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  }

  reopenSubcontractorApplication = async (id: number): Promise<SubcontractorApplication> => {
    return this.request(`/docs/subcontractor-applications/${id}/reopen`, { method: 'POST' })
  }

  deleteSubcontractorApplication = async (id: number): Promise<{ success: boolean }> => {
    return this.request(`/docs/subcontractor-applications/${id}`, { method: 'DELETE' })
  }

  checkAssetDraftStatus = async (assetUid: string): Promise<{
    in_draft: boolean
    act_id?: number
    act_number?: string
    act_name?: string
    created_by?: string
    is_mine?: boolean
  }> => {
    return this.request<{
      in_draft: boolean
      act_id?: number
      act_number?: string
      act_name?: string
      created_by?: string
      is_mine?: boolean
    }>(`/docs/asset/${assetUid}/draft-status`)
  }

  getAssetDocumentHistory = async (assetUid: string): Promise<AssetDocumentHistoryItem[]> => {
    return this.request<AssetDocumentHistoryItem[]>(`/docs/asset/${assetUid}/document-history`)
  }

  // РќР°РєР»Р°РґРЅС‹Рµ
  createWaybill = async (data: CreateWaybillData): Promise<Waybill> => {
    return this.request<Waybill>('/docs/waybill', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  getWaybills = async (status: 'draft' | 'archived' = 'draft', mine: boolean = true): Promise<Waybill[]> => {
    const params = new URLSearchParams({
      status,
      mine: mine.toString(),
    })
    return this.request<Waybill[]>(`/docs/waybill?${params}`)
  }

  getNextWaybillNumber = async (origin: string, purpose: string, year: number): Promise<NextDocumentNumber> => {
    const params = new URLSearchParams({ origin, purpose, year: String(year) })
    return this.request<NextDocumentNumber>(`/docs/waybill/next-number?${params}`)
  }

  getWaybill = async (waybillId: number): Promise<Waybill> => {
    return this.request<Waybill>(`/docs/waybill/${waybillId}`)
  }

  getWaybillPhotos = async (waybillId: number): Promise<{ photos: WaybillPhoto[] }> => {
    return this.request(`/docs/waybill/${waybillId}/photos`)
  }

  suggestWaybillPhotoFolder = async (waybillId: number, sender?: string, direction?: string): Promise<WaybillPhotoSuggestion> => {
    const params = new URLSearchParams()
    if (sender) params.set('sender', sender)
    if (direction) params.set('direction', direction)
    return this.request(`/docs/waybill/${waybillId}/photos/suggest?${params.toString()}`)
  }

  listWaybillPhotoFolder = async (
    waybillId: number,
    folder: { sender: string; direction: string; date: string },
  ): Promise<{ photos: WaybillPhoto[] }> => {
    return this.request(`/docs/waybill/${waybillId}/photos/folder`, { method: 'POST', body: JSON.stringify(folder) })
  }

  linkWaybillPhotos = async (waybillId: number, photoIds: number[]): Promise<{ linked: number }> => {
    return this.request(`/docs/waybill/${waybillId}/photos/link`, { method: 'POST', body: JSON.stringify({ photo_ids: photoIds }) })
  }

  unlinkWaybillPhotos = async (waybillId: number, photoIds: number[]): Promise<{ unlinked: number }> => {
    return this.request(`/docs/waybill/${waybillId}/photos/unlink`, { method: 'POST', body: JSON.stringify({ photo_ids: photoIds }) })
  }

  getLabTransferLabs = async (): Promise<LabTransferLabs> => this.request('/lab-transfers/labs')

  listLabTransfers = async (status = '', mine = false): Promise<{ transfers: LabTransfer[] }> => {
    const params = new URLSearchParams()
    if (status) params.set('status', status)
    if (mine) params.set('mine', 'true')
    return this.request(`/lab-transfers?${params.toString()}`)
  }

  createLabTransfer = async (payload: {
    asset_uids: string[]; lab_unit_id?: number | null; lab_name?: string
    assignee_email?: string; assignee_name?: string; note?: string
  }): Promise<LabTransfer> => this.request('/lab-transfers', { method: 'POST', body: JSON.stringify(payload) })

  getLabTransfer = async (id: number): Promise<LabTransfer> => this.request(`/lab-transfers/${id}`)

  updateLabTransfer = async (id: number, payload: Partial<Pick<LabTransfer, 'lab_unit_id' | 'lab_name' | 'assignee_email' | 'assignee_name' | 'note'>>): Promise<LabTransfer> =>
    this.request(`/lab-transfers/${id}`, { method: 'PATCH', body: JSON.stringify(payload) })

  deleteLabTransfer = async (id: number): Promise<{ deleted: boolean }> =>
    this.request(`/lab-transfers/${id}`, { method: 'DELETE' })

  removeLabTransferItems = async (id: number, assetUids: string[]): Promise<{ removed: number }> =>
    this.request(`/lab-transfers/${id}/items/remove`, { method: 'POST', body: JSON.stringify({ asset_uids: assetUids }) })

  sendLabTransfer = async (id: number): Promise<{ transfer: LabTransfer; errors: string[] }> =>
    this.request(`/lab-transfers/${id}/send`, { method: 'POST' })

  refreshLabTransfer = async (id: number): Promise<LabTransfer> =>
    this.request(`/lab-transfers/${id}/refresh`, { method: 'POST' })

  suggestLabTransferPhotoFolder = async (id: number, sender?: string, direction?: string): Promise<WaybillPhotoSuggestion> => {
    const params = new URLSearchParams()
    if (sender) params.set('sender', sender)
    if (direction) params.set('direction', direction)
    return this.request(`/lab-transfers/${id}/photos/suggest?${params.toString()}`)
  }

  listLabTransferPhotoFolder = async (id: number, folder: { sender: string; direction: string; date: string }): Promise<{ photos: WaybillPhoto[] }> =>
    this.request(`/lab-transfers/${id}/photos/folder`, { method: 'POST', body: JSON.stringify(folder) })

  linkLabTransferPhotos = async (id: number, photoIds: number[]): Promise<{ linked: number }> =>
    this.request(`/lab-transfers/${id}/photos/link`, { method: 'POST', body: JSON.stringify({ photo_ids: photoIds }) })

  unlinkLabTransferPhotos = async (id: number, photoIds: number[]): Promise<{ unlinked: number }> =>
    this.request(`/lab-transfers/${id}/photos/unlink`, { method: 'POST', body: JSON.stringify({ photo_ids: photoIds }) })

  getWaybillItems = async (waybillId: number): Promise<WaybillItem[]> => {
    return this.request<WaybillItem[]>(`/docs/waybill/${waybillId}/items`)
  }

  addWaybillItem = async (waybillId: number, assetUid: string, ownerTitle: string): Promise<{ id: number; message: string }> => {
    return this.request<{ id: number; message: string }>(`/docs/waybill/${waybillId}/items`, {
      method: 'POST',
      body: JSON.stringify({ asset_uid: assetUid, owner_title: ownerTitle }),
    })
  }

  addManualWaybillItem = async (waybillId: number, data: { name: string; serial: string; owner: string; destination: string; qty: string }): Promise<{ id: number; message: string }> => {
    return this.request<{ id: number; message: string }>(`/docs/waybill/${waybillId}/items/manual`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  updateManualWaybillItem = async (waybillId: number, itemId: number, data: { name: string; serial: string; owner: string; destination: string; qty: string }): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/waybill/${waybillId}/items/${itemId}/manual`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  }
  removeWaybillItem = async (waybillId: number, itemId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/waybill/${waybillId}/items/${itemId}`, {
      method: 'DELETE',
    })
  }

  updateWaybillItemDestination = async (waybillId: number, itemId: number, destination: string): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/waybill/${waybillId}/items/${itemId}/destination`, {
      method: 'PUT',
      body: JSON.stringify({ destination }),
    })
  }

  updateWaybillItemRostestPdf = async (waybillId: number, itemId: number, include: boolean): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/waybill/${waybillId}/items/${itemId}/rostest-pdf`, {
      method: 'PUT',
      body: JSON.stringify({ include }),
    })
  }

  checkWaybillRostestCertificates = async (waybillId: number): Promise<RostestDocumentJob> => {
    return this.request<RostestDocumentJob>(`/docs/waybill/${waybillId}/rostest-certificates/check`, { method: 'POST' })
  }

  getRostestDocumentJob = async (jobId: string): Promise<RostestDocumentJob> => {
    return this.request<RostestDocumentJob>(`/docs/rostest-certificate-jobs/${jobId}`)
  }

  downloadDocumentRostestPackage = async (documentType: 'shipment' | 'waybill', documentId: number): Promise<{ blob: Blob; filename: string }> => {
    const url = `${this.baseUrl}/docs/${documentType}/${documentId}/rostest-package`
    const authToken: string | null = null
    const response = await fetch(url, {
      credentials: 'include',
      headers: { ...(authToken && { Authorization: `Bearer ${authToken}` }) },
    })
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Не удалось собрать комплект документов' }))
      throw new Error(error.detail || `HTTP error! status: ${response.status}`)
    }
    const blob = await response.blob()
    const contentDisposition = response.headers.get('content-disposition') || ''
    const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i)
    const filename = filenameMatch
      ? decodeURIComponent(filenameMatch[1].replace(/"/g, ''))
      : `document_${documentId}_certificates.zip`
    return { blob, filename }
  }

  finalizeWaybill = async (waybillId: number): Promise<{ file_url: string }> => {
    return this.request<{ file_url: string }>(`/docs/waybill/${waybillId}/finalize`, {
      method: 'POST',
    })
  }

  reopenWaybill = async (waybillId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/waybill/${waybillId}/reopen`, {
      method: 'POST',
    })
  }

  deleteWaybill = async (waybillId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/waybill/${waybillId}`, {
      method: 'DELETE',
    })
  }

  // === Р‘РР РљР ===
  
  createTag = async (data: { contract_code: string; tag_date: string; notes?: string }): Promise<Tag> => {
    return this.request<Tag>('/docs/tags', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  getTags = async (mine: boolean = true): Promise<Tag[]> => {
    const params = new URLSearchParams()
    params.append('mine', mine.toString())
    return this.request<Tag[]>(`/docs/tags?${params.toString()}`)
  }

  getTag = async (tagId: number): Promise<Tag> => {
    return this.request<Tag>(`/docs/tags/${tagId}`)
  }

  addTagItem = async (tagId: number, data: { asset_uid: string; note?: string }): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/tags/${tagId}/items`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  removeTagItem = async (tagId: number, itemId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/tags/${tagId}/items/${itemId}`, {
      method: 'DELETE',
    })
  }

  getTagItems = async (tagId: number): Promise<TagItem[]> => {
    return this.request<TagItem[]>(`/docs/tags/${tagId}/items`)
  }

  finalizeTag = async (tagId: number): Promise<{ file_url: string }> => {
    return this.request<{ file_url: string }>(`/docs/tags/${tagId}/finalize`, {
      method: 'POST',
    })
  }

  deleteTag = async (tagId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/tags/${tagId}`, {
      method: 'DELETE',
    })
  }

  // === Р‘РР РљР РќРђ РџР•Р§РђРўР¬ ===
  
  createPrintTag = async (data: CreatePrintTagData): Promise<{ id: number; message: string }> => {
    return this.request<{ id: number; message: string }>('/docs/print-tags', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  getPrintTags = async (status: string = 'draft'): Promise<{ print_tags: PrintTag[] }> => {
    return this.request<{ print_tags: PrintTag[] }>(`/docs/print-tags?status=${status}`)
  }

  getPrintTag = async (printTagId: number): Promise<{ print_tag: PrintTag }> => {
    return this.request<{ print_tag: PrintTag }>(`/docs/print-tags/${printTagId}`)
  }

  addPrintTagItem = async (printTagId: number, assetUid: string, note?: string, copies: number = 1): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/print-tags/${printTagId}/items`, {
      method: 'POST',
      body: JSON.stringify({
        asset_uid: assetUid,
        note: note,
        copies: copies
      }),
    })
  }

  getPrintTagItems = async (printTagId: number): Promise<{ items: PrintTagItem[] }> => {
    return this.request<{ items: PrintTagItem[] }>(`/docs/print-tags/${printTagId}/items`)
  }

  updatePrintTagItem = async (printTagId: number, itemId: number, note?: string, copies?: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/print-tags/${printTagId}/items/${itemId}`, {
      method: 'PUT',
      body: JSON.stringify({
        note: note,
        copies: copies
      }),
    })
  }

  removePrintTagItem = async (printTagId: number, itemId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/print-tags/${printTagId}/items/${itemId}`, {
      method: 'DELETE',
    })
  }

  finalizePrintTag = async (printTagId: number): Promise<{ message: string; file_url: string; file_path: string }> => {
    return this.request<{ message: string; file_url: string; file_path: string }>(`/docs/print-tags/${printTagId}/finalize`, {
      method: 'POST',
    })
  }

  deletePrintTag = async (printTagId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/print-tags/${printTagId}`, {
      method: 'DELETE',
    })
  }

  getPrintTagsForDropdown = async (): Promise<DropdownPrintTag[]> => {
    return this.request<DropdownPrintTag[]>('/docs/print-tags/dropdown')
  }

  // === СКАНЕР И РЕЕСТР ===

  searchRegistry = async (
    query: string,
    topK: number = 10,
    years?: number[]
  ): Promise<{ query: string; years: number[]; results: RegistrySearchResult[] }> => {
    const params = new URLSearchParams()
    params.set('query', query)
    params.set('top_k', String(topK))
    if (years && years.length > 0) {
      params.set('years', years.join(','))
    }
    return this.request<{ query: string; years: number[]; results: RegistrySearchResult[] }>(
      `/docs/registry/search?${params.toString()}`
    )
  }

  scanDistributionDocuments = async (
    files: File[],
    options?: { title?: string; notes?: string; year?: number }
  ): Promise<{ tab_id: number; title: string; files: string[]; items_count: number; distribution: Array<{ performer: string; items_count: number }> }> => {
    const formData = new FormData()
    files.forEach(file => formData.append('files', file))
    if (options?.title) formData.append('title', options.title)
    if (options?.notes) formData.append('notes', options.notes)
    if (options?.year) formData.append('year', String(options.year))

    return this.request<{ tab_id: number; title: string; files: string[]; items_count: number; distribution: Array<{ performer: string; items_count: number }> }>(
      '/docs/distributions/scan',
      {
        method: 'POST',
        body: formData,
      }
    )
  }

  // Интерпретатор документов: позиции из файлов + исполнитель, цена и срок по истории работ.
  analyzeDocuments = async (files: File[], vatRate: number): Promise<InterpreterResult> => {
    const formData = new FormData()
    files.forEach((file) => formData.append('files', file))
    formData.append('vat_rate', String(vatRate))
    return this.request('/docs/interpreter/analyze', { method: 'POST', body: formData })
  }

  exportInterpreterRows = (rows: InterpreterRow[], vatRate: number) => {
    return this.requestBlob('/docs/interpreter/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ rows, vat_rate: vatRate }),
    })
  }

  createDistributionTab = async (payload: { title: string; notes?: string; year?: number }): Promise<{ id: number; message: string }> => {
    const formData = new FormData()
    formData.append('title', payload.title)
    if (payload.notes) formData.append('notes', payload.notes)
    if (payload.year) formData.append('year', String(payload.year))

    return this.request<{ id: number; message: string }>('/docs/distributions', {
      method: 'POST',
      body: formData,
    })
  }

  getDistributionTabs = async (status: 'draft' | 'archived' = 'draft', mine: boolean = true): Promise<{ tabs: DistributionTab[] }> => {
    return this.request<{ tabs: DistributionTab[] }>(`/docs/distributions?status=${status}&mine=${mine}`)
  }

  getDistributionTab = async (tabId: number): Promise<{ tab: DistributionTab; items: DistributionItem[]; distribution: Array<{ performer: string; items_count: number }> }> => {
    return this.request<{ tab: DistributionTab; items: DistributionItem[]; distribution: Array<{ performer: string; items_count: number }> }>(`/docs/distributions/${tabId}`)
  }

  addManualDistributionItem = async (
    tabId: number,
    payload: {
      in_name: string
      in_type?: string
      in_serial?: string
      quantity?: number
      matched_asset_uid?: string
      performer?: string
      estimated_external_cost?: number
    }
  ): Promise<{ id: number; message: string }> => {
    return this.request<{ id: number; message: string }>(`/docs/distributions/${tabId}/items/manual`, {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  }

  updateDistributionItem = async (
    tabId: number,
    itemId: number,
    payload: {
      performer?: string
      estimated_external_cost?: number
      matched_asset_uid?: string
      matched?: boolean
      confidence?: string
      score?: number
      ambiguous?: boolean
    }
  ): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/distributions/${tabId}/items/${itemId}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    })
  }

  deleteDistributionItem = async (tabId: number, itemId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/distributions/${tabId}/items/${itemId}`, {
      method: 'DELETE',
    })
  }

  deleteDistributionTab = async (tabId: number): Promise<{ message: string }> => {
    return this.request<{ message: string }>(`/docs/distributions/${tabId}`, {
      method: 'DELETE',
    })
  }

  listNotifications = async (
    includeDone: boolean = false,
    options?: { newOnly?: boolean; days?: number },
  ): Promise<{ notifications: AppNotification[] }> => {
    const params = new URLSearchParams()
    params.set('include_done', String(includeDone))
    if (options?.newOnly) params.set('new_only', 'true')
    if (options?.days) params.set('days', String(options.days))
    return this.request<{ notifications: AppNotification[] }>(`/notifications?${params.toString()}`)
  }

  getNotificationsUnreadCount = async (days: number = 30): Promise<{ unread: number; critical: number; new_unread: number }> => {
    return this.request<{ unread: number; critical: number; new_unread: number }>(`/notifications/unread-count?days=${days}`)
  }

  markNotificationRead = async (notificationId: number): Promise<{ success: boolean }> => {
    return this.request<{ success: boolean }>(`/notifications/${notificationId}/read`, { method: 'POST' })
  }

  markNotificationDone = async (notificationId: number): Promise<{ success: boolean }> => {
    return this.request<{ success: boolean }>(`/notifications/${notificationId}/done`, { method: 'POST' })
  }

  markAllNotificationsDone = async (): Promise<{ success: boolean; updated: number }> => {
    return this.request<{ success: boolean; updated: number }>(`/notifications/mark-all-done`, { method: 'POST' })
  }

  getNotificationSettings = async (): Promise<{ settings: NotificationSetting[] }> => {
    return this.request<{ settings: NotificationSetting[] }>('/notifications/settings')
  }

  updateNotificationSetting = async (email: string, enabled: boolean): Promise<{ setting: NotificationSetting }> => {
    return this.request<{ setting: NotificationSetting }>(`/notifications/settings/${encodeURIComponent(email)}`, {
      method: 'PUT',
      body: JSON.stringify({ enabled }),
    })
  }

  getExecutorJobs = async (status?: string): Promise<{ jobs: ExecutorInvoiceJob[] }> => {
    const query = status ? `?status=${encodeURIComponent(status)}` : ''
    return this.request<{ jobs: ExecutorInvoiceJob[] }>(`/executor-requests/jobs${query}`)
  }

  getExecutorRequest = async (requestId: number): Promise<ExecutorRequestDetails> => {
    return this.request<ExecutorRequestDetails>(`/executor-requests/${requestId}`)
  }

  getExecutorRequestDownloadUrl = (requestId: number): string => {
    return `${this.baseUrl}/executor-requests/${requestId}/download`
  }

  downloadExecutorRequest = async (requestId: number): Promise<{ blob: Blob; filename: string }> => {
    const url = `${this.baseUrl}/executor-requests/${requestId}/download`
    const authToken: string | null = null

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
      },
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Download failed' }))
      throw new Error(error.detail || `HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()
    const contentDisposition = response.headers.get('content-disposition') || ''
    const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|")?([^\";]+)/i)
    const filename = filenameMatch ? decodeURIComponent(filenameMatch[1].replace(/"/g, '')) : `executor_request_${requestId}.docx`
    return { blob, filename }
  }

  getAssetExecutorRequestStatus = async (assetUid: string, year?: number): Promise<AssetExecutorRequestStatus> => {
    const url = addYearParam(`/assets/${assetUid}/executor-request`, year)
    return this.request<AssetExecutorRequestStatus>(url)
  }

  checkAssetExecutorRequest = async (assetUid: string, year?: number): Promise<AssetExecutorRequestStatus & { success: boolean; indexed?: number; matched?: number }> => {
    const url = addYearParam(`/assets/${assetUid}/executor-request/check`, year)
    return this.request<AssetExecutorRequestStatus & { success: boolean; indexed?: number; matched?: number }>(url, { method: 'POST' })
  }

  // === РђР’РўРћР РР—РђР¦РРЇ ===
  
  loginViaEmail = async (email: string, password: string): Promise<AuthResponse> => {
    return this.request<AuthResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    })
  }

  changeStaffPassword = async (currentPassword: string, newPassword: string): Promise<{ success: boolean }> => {
    return this.request('/auth/password/change', {
      method: 'POST',
      body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
    })
  }

  logout = async (): Promise<{ success: boolean; message: string }> => {
    return this.request<{ success: boolean; message: string }>('/auth/logout', {
      method: 'POST',
    })
  }

  getGateConfig = async (): Promise<{ enabled: boolean; available?: boolean; origin: string }> => {
    return this.request('/auth/gate-config')
  }

  getGatePalette = async (): Promise<{ palette: string | null; source: 'task' | 'gate' | null }> => {
    return this.request('/auth/palette')
  }

  saveGatePalette = async (palette: string): Promise<{ palette: string | null; synced: boolean }> => {
    return this.request('/auth/palette', { method: 'PUT', body: JSON.stringify({ palette }) })
  }

  getCurrentUser = async (): Promise<User> => {
    return this.request<User>('/auth/me-cookie', {
      method: 'GET',
    })
  }

  listStaffDirectory = async (): Promise<{ users: StaffDirectoryUser[] }> => {
    return this.request<{ users: StaffDirectoryUser[] }>('/auth/staff-directory', {
      method: 'GET',
    })
  }

  addStaffDirectoryUser = async (email: string, name: string): Promise<{ success: boolean; user: StaffDirectoryUser }> => {
    return this.request<{ success: boolean; user: StaffDirectoryUser }>('/auth/staff-directory', {
      method: 'POST',
      body: JSON.stringify({ email, name }),
    })
  }

  getEmployeeAccount = async (): Promise<EmployeeAccountData> => {
    return this.request<EmployeeAccountData>('/employee-account')
  }

  getEmployeeDocuments = async (filters: {
    document_type?: string
    status?: string
    year?: number
    query?: string
    page?: number
    page_size?: number
  } = {}): Promise<EmployeeAccountPage<EmployeeAccountDocument>> => {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') params.set(key, String(value))
    })
    return this.request<EmployeeAccountPage<EmployeeAccountDocument>>(`/employee-account/documents?${params}`)
  }

  getEmployeeCustomerRequests = async (filters: {
    request_type?: string
    status?: string
    page?: number
    page_size?: number
  } = {}): Promise<EmployeeAccountPage<EmployeeAccountRequest>> => {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') params.set(key, String(value))
    })
    return this.request<EmployeeAccountPage<EmployeeAccountRequest>>(`/employee-account/customer-requests?${params}`)
  }

  getWaybillsForDropdown = async (): Promise<DropdownDoc[]> => {
    return this.request<DropdownDoc[]>('/docs/waybill/for-dropdown')
  }

  // Р Р°СЃС€РёСЂРµРЅРЅР°СЏ С„РёРЅР°Р»РёР·Р°С†РёСЏ Р°РєС‚Р° СЃ РѕРїС†РёРѕРЅР°Р»СЊРЅРѕР№ РґР°С‚РѕР№ РґРѕРєСѓРјРµРЅС‚Р°
  finalizeShipmentActWithDate = async (actId: number, documentDate?: string): Promise<{ file_url: string }> => {
    const body = documentDate ? { document_date: documentDate } : {}
    return this.request<{ file_url: string }>(`/docs/shipment/${actId}/finalize`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  }
}

// Р­РєСЃРїРѕСЂС‚РёСЂСѓРµРј СЌРєР·РµРјРїР»СЏСЂ РєР»РёРµРЅС‚Р°
export const api = new ApiClient()

export interface JournalColumn {
  key: string
  label: string
  group: string
  kind: 'text' | 'date' | 'number' | 'money' | 'link' | 'status' | 'list'
  sortable: boolean
  filterable: boolean
  future: boolean
  hint: string
}

export interface JournalFilter {
  key: string
  value?: string
  from?: string
  to?: string
  min?: number
  max?: number
  empty?: boolean
}

export interface ManualItemsQuery {
  kind?: string
  status?: string
  date_from?: string
  date_to?: string
  search?: string
  page?: number
  page_size?: number
}

export interface ManualItemsResult {
  columns: Array<{ key: string; label: string; kind: string }>
  rows: Array<Record<string, string | number | null> & { _id: string }>
  total: number
  page: number
  pages: number
  page_size: number
}
export interface JournalQuery {
  columns: string[]
  contracts?: string[]
  year?: number | null
  statuses?: string[]
  search?: string
  include_inactive?: boolean
  /** ЗК Ростеста: all — приборы Ростеста, has — и ЗК найдена, missing — ЗК нет */
  rostest_zk?: '' | 'all' | 'has' | 'missing'
  /** Выдача Ростестом по «Расшифровке услуги» ЗК: issued — выдан нам, pending — в ЗК, но не выдан */
  rostest_item?: '' | 'issued' | 'pending'
  filters?: JournalFilter[]
  sort?: Array<{ key: string; dir: 'asc' | 'desc' }>
  page?: number
  page_size?: number
}

export interface JournalPreset extends Partial<JournalQuery> {
  id: string
  name: string
  columns: string[]
}

export interface JournalMeta {
  groups: Array<{ key: string; label: string }>
  columns: JournalColumn[]
  statuses: Array<{ key: string; label: string }>
  presets: JournalPreset[]
  default_columns: string[]
  contracts: Array<{ code: string; title: string; year: number; division?: string; assets: number }>
  years: number[]
}

export interface JournalResult {
  columns: string[]
  rows: Array<Record<string, string | number | null> & { _uid: string }>
  total: number
  page: number
  pages: number
  page_size: number
}

export interface JournalView {
  id: number
  name: string
  config: JournalQuery
}

export interface JournalTimeline {
  asset: { asset_uid: string; name: string; type_si: string; serial: string; contract_title: string; owner: string; branch: string }
  events: Array<{ at: string; date: string; kind: string; title: string; detail: string; url: string; actor: string }>
}

export interface InterpreterRow {
  n: number
  file: string
  source_row: number
  name: string
  type_si: string
  mit_number: string
  serial: string
  quantity: number
  performer: string
  cost_without_vat: number | null
  cost_with_vat: number | null
  lead_days: number | null
  status: 'priced' | 'mit' | 'no_match' | 'no_price'
  message: string
  score: number
  matched_instrument?: { name: string; type_si: string; mit_number: string } | null
  alternatives: Array<{ performer?: string; cost_min?: number | null; cost_max?: number | null; lead_days?: number | null; records_count?: number; year?: number }>
}

export interface InterpreterResult {
  files: Array<{ filename: string; ok: boolean; error?: string; items: number; source_type?: string; needs_review?: boolean }>
  vat_rate: number
  rows: InterpreterRow[]
  summary: {
    total_rows: number
    total_quantity: number
    counts: Record<string, number>
    sum_without_vat: number
    lead_days_max: number | null
    performers: Array<{ performer: string; items: number; sum_without_vat: number }>
  }
}
